import React from 'react'
import * as styles from './IncommRetailerInstructions.module.scss'
import { IncommRetailerCashierInstructions } from './IncommRetailerCashierInstructions'
import { Divider } from '@mui/material'

const OTC_NETWORK_LOGO_URL =
  'https://s3.us-east-1.amazonaws.com/dailybreak_images_prod/retailer-store-icons/otc-network-logo.png'

interface IncommRetailerInstructionsProps {
  retailerInstructions: {
    logoUrl: string
    digitalPaymentMessage: {
      title: string
      description: string
    }
    cashierInstructions: {
      title: string
      description: string
    }
  }
}

export const IncommRetailerInstructions = ({
  retailerInstructions,
}: IncommRetailerInstructionsProps) => {
  return (
    <div className={styles.incommRetailerInstructions}>
      <img
        src={retailerInstructions.logoUrl}
        alt={retailerInstructions.digitalPaymentMessage.title}
        className={styles.incommRetailerInstructionsLogo}
      />
      <div className={styles.incommRetailerInstructionsTitle}>
        {retailerInstructions.digitalPaymentMessage.title}
      </div>
      <div className={styles.incommRetailerInstructionsDescription}>
        {retailerInstructions.digitalPaymentMessage.description}
      </div>
      <Divider
        variant="fullWidth"
        sx={{ mb: 2, color: 'black', width: 'calc(100% + 4rem)' }}
      />
      <IncommRetailerCashierInstructions
        title={retailerInstructions.cashierInstructions.title}
        description={retailerInstructions.cashierInstructions.description}
      />
      <img
        src={OTC_NETWORK_LOGO_URL}
        alt={retailerInstructions.digitalPaymentMessage.title}
        className={styles.incommRetailerInstructionsOtcNetworkLogo}
      />
      <Divider
        variant="fullWidth"
        sx={{ mt: 2, color: 'black', width: 'calc(100% + 4rem)' }}
      />
    </div>
  )
}
